import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { AuthenticationService } from "src/app/_app-core/services/authenticationService";
import { JswVmdService } from "src/app/_app-core/services/jsw-vmd/jsw-vmd.service";

@Component({
  selector: "app-sign-in",
  templateUrl: "./sign-in.component.html",
  styleUrls: ["./sign-in.component.scss"],
})
export class SignInComponent implements OnInit, OnDestroy {
  private paramSub: Subscription;
  loginData = new FormGroup({
    username: new FormControl(null, Validators.required),
    password: new FormControl(null, Validators.required),
  });

  onboardToken: string = "";
  responseData: any;
  isLoading: boolean = false;
  isError: boolean = false;
  isServerError: boolean = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private authenticationService: AuthenticationService,
    private jswVmd: JswVmdService,
  ) {}

  saveToken(eippSession: any, sessionId: any, name: any, vendor: any, sellerCode: any, nonPo_flag: any, logistics_flag: any, contact: any, email: any) {

    localStorage.setItem("eippSession", eippSession);
    localStorage.setItem("sessionId", sessionId);
    localStorage.setItem("displayName", name);
    localStorage.setItem("vendorCode", vendor);
    localStorage.setItem("contact", contact);
    localStorage.setItem("sellerCode", sellerCode);
    localStorage.setItem("logisticFlag", logistics_flag);
    localStorage.setItem("nonPoFlag", nonPo_flag);
    localStorage.setItem("vendorEmail", email);
  }

  onLogin() {
    this.isError = false;
    this.isServerError = false;
    this.isLoading = true;
    const req: { username: string; password: string; onboardToken?: string } = {
      username: this.loginData.value.username.replaceAll(/\s/g, ""),
      password: this.loginData.value.password,
    };
    if (this.onboardToken) {
      req.onboardToken = this.onboardToken;
    }
    this.authService.signIn(req).subscribe(
      (res) => {
        this.responseData = res;
        this.isLoading = false;
        if (this.responseData.success) {
          const vendorCode = this.responseData.data.user.eippSession.username;
          const eippSession = this.responseData.data.user.eippSession.sessionId;
          const sessionId = this.responseData.data.session.sessionId;
          const displayName = this.responseData.data.user.displayName;
          const sellerCode = this.responseData.data.user.sellerCode;
          const nonPoFlag = this.responseData.data.user.eippSessionData.data.user.nonPoFlag;
          const logisticFlag = this.responseData.data.user.eippSessionData.data.user.logisticsFlag;
          const contact = this.responseData.data.user.eippSessionData.data.user.mobile;
          const email = this.responseData.data.user.eippSessionData.data.user.email;
          this.saveToken(eippSession, sessionId, displayName, vendorCode, sellerCode, nonPoFlag, logisticFlag, contact, email);
          sessionStorage.removeItem("onboardToken");
          this.authService.setCurrentUser(this.responseData.data.user);
          this.authenticationService.setCurrentUser(this.responseData.data.user);
          const enforcePasswordChange =
            this.responseData.data.user.eippSessionData.data.user.enforcePasswordChange;
          const targetUrl = enforcePasswordChange ? "/vendor-master-data" : "/purchase-orders";
          this.jswVmd.fetchAndStoreForVendor(vendorCode).subscribe(() => {
            this.isLoading = false;
            this.router.navigateByUrl(targetUrl);
          });
        } else {
          this.isLoading = false;
          if (this.responseData.message === "Invalid username or password" || this.responseData.message === "Invalid credentials or user not active") {
            this.isError = true;
          } else {
            this.isServerError = true;
          }
        }
      },
      (error) => {
        if (this.invalidCredentialMessages.includes(error?.message)) {
          this.isError = true;
        } else {
          this.isServerError = true;
        }
        this.isLoading = false;
      },
    );
  }

  ngOnInit(): void {
    this.paramSub = this.route.queryParams.subscribe((params) => {
      if (params["token"]) {
        sessionStorage.setItem("onboardToken", params["token"]);
      }
      const storedToken = sessionStorage.getItem("onboardToken");
      if (storedToken) {
        this.onboardToken = storedToken;
        sessionStorage.removeItem("onboardToken");
      }
    });
  }

  ngOnDestroy(): void {
    this.paramSub?.unsubscribe();
  }

  private readonly invalidCredentialMessages = ["Invalid username or password", "Invalid credentials or user not active", "Please Enter Correct Username Or Password"];
}
